<template>
  <div>
    <v-menu
      v-model="isOpen"
      content-class="elevation-0"
      class="radius "
    >
      <template v-slot:activator="{ on, attrs, value }">
        <v-btn
          color="branche"
          class="btn-header"
          elevation="0"
          rounded
          :icon="$vuetify.breakpoint.mobile"
          v-bind="attrs"
          v-on="on"
        >
          <v-icon
            class="--text-branche"    
            start           
          >
            mdi-apps
          </v-icon>
          <span
            v-if="!$vuetify.breakpoint.mobile"
            class="action text-truncate --text-branche"     
          >Accès rapides</span>
          <v-icon
            v-if="!$vuetify.breakpoint.mobile"
            class="--text-branche"
          >
            {{ isOpen ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
          </v-icon>
        </v-btn>
      </template>
      <v-card
        elevation="2"
        class="mt-12 pt-1 card-oad"
      >
        <v-btn
          v-if="!isNonAgr"
          plain
          block
          class="texte py-12 black--text"
          @click="onClickMonAgrial()"
        >
          <div class="d-flex flex-column justify-center ">
            <img
              class="icone-agrial align-self-center"
              src="@/assets/mon-agrial.svg"
            >
            <div>
              <span class="align-self-center">Accéder à Mon Agrial</span>
              <v-icon
                class="align-self-center"
                color="primary"
              >
                mdi-chevron-right
              </v-icon>
            </div>
          </div>
        </v-btn>
        <div class="d-flex border-top pl-4 py-1 texte border texte texte-gris-fonce background-acces-rapide">
          Outil de vente
        </div>
        <v-btn
          plain
          block
          elevation="0"
          class="py-6"
          @click="onClickBAG()"
        >
          <div class="align-left d-flex">
            <img
              class="align-self-center"
              src="@/assets/icon-bag-ar.svg"
            >
            <span class="align-self-center texte ml-2">Bourse aux grains</span>
          </div>
        </v-btn>
        <div
          class="d-flex pl-4 py-1 border-top texte texte-gris-fonce background-acces-rapide"
        >
          OAD
        </div>
        <v-row
          no-gutters
          justify="space-between"
        >
          <v-col cols="6">
            <v-btn
              plain
              block
              elevation="0"
              class="py-6 px-0"
              @click="onClickAgrialSAT()"
            >
              <img
                class="align-self-center"
                :class="$vuetify.breakpoint.mobile ? 'logo-agrialSAT-mobile' : 'logo-agrialSAT'"
                src="@/assets/logo_Agrial SAT.png"
              >
              <span
                :class="$vuetify.breakpoint.mobile ? 'mention' : 'texte'"
              >Agrial'SAT</span>
            </v-btn>
          </v-col>
          <v-col cols="6">
            <v-btn
              plain
              block
              elevation="0"
              class="py-6 px-0 pl-1"
              @click="onClickXarvio()"
            >
              <div
                class="d-flex"
                :class="$vuetify.breakpoint.mobile ? 'margin-xarvio-mobile' : 'margin-xarvio'"
              >
                <img
                  class="logo-xarvio align-self-center"
                  src="@/assets/icon-xarvioV2.png"
                >
                <span
                  class="pl-2 align-self-center"
                  :class="$vuetify.breakpoint.mobile ? 'mention' : 'texte'"
                >Xarvio</span>
              </div>
            </v-btn>
          </v-col>
        </v-row>
        <v-divider />
        <v-row
          no-gutters
        >
          <v-col
            cols="6"
          >
            <v-btn
              plain
              block
              elevation="0"
              class="py-6 px-0"
              @click="onClickFarmstar()"
            >
              <img
                class="logo-farmstar"
                src="@/assets/icon-farmstarV3.svg"
              >
              <span
                class="pl-1 pl-md-2"
                :class="$vuetify.breakpoint.mobile ? 'mention' : 'texte'"
              >Farmstar</span>
            </v-btn>
          </v-col>
          <v-col
            v-if="abonnements.smagFarmer"
            cols="6"
          >
            <v-btn
              plain
              block
              elevation="0"
              class="py-6 px-0 pr-16"
              @click="onClickSmagFarmer()"
            >
              <img src="@/assets/icon-smag-ar.svg">
              <span
                class="pl-0"
                :class="$vuetify.breakpoint.mobile ? 'mention' : 'texte'"
              >Smag Farmer</span>
            </v-btn>
          </v-col>
        </v-row>
      </v-card>
    </v-menu>
  </div>
</template>

<script>

import { mapGetters } from 'vuex'

export default {
  name: 'AccesRapide',
  props: {
    isNonAgr: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isOpen: false,
      urlMonAgrial: window.PROPERTIES.get('URL_PORTAIL'),
      urlBAG: window.PROPERTIES.get('URL_BOURSE_AUX_GRAINS'),
      urlSmagFarmer: window.PROPERTIES.get('URL_SMAGFARMER'),
      urlFarmstar: window.PROPERTIES.get('URL_FARMSTAR'),
      urlXarvio: window.PROPERTIES.get('URL_XARVIO'),
      urlAgrialSAT: window.PROPERTIES.get('URL_AGRIALSAT')
    }
  },
  computed: {
    ...mapGetters({
      abonnements: 'adherent/abonnements'
    }),
  },
  methods: {    
    onClickMonAgrial () {
      window.open(this.urlMonAgrial)
    },
    onClickBAG () {
      window.open(this.urlBAG)
    },
    onClickFarmstar () {
      window.open(this.urlFarmstar)
    },
    onClickXarvio () {
      window.open(this.urlXarvio)
    },
    onClickSmagFarmer () {
      window.open(this.urlSmagFarmer)
    },
    onClickAgrialSAT () {
      window.open(this.urlAgrialSAT)
    }
  }
}
</script>

<style lang="scss" scoped>
.card {
  top: 70px;
}
.card-mobile {
  right:10px;
}
.v-btn:hover {
  background-color: #e0e0e0 !important;
}
.icone-agrial {
  width: 70%;
}
.background-acces-rapide {
  background: var(--gris);
}
.texte-gris-fonce {
  color: var(--gris-fonce);
}
.border-top {
  border-top: 1px solid;
  border-color: #d7d8d6;
}
.align-left {
  position: absolute;
  left: 0;
}
.logo-agrialSAT {
  width: 2.5rem;
}
.logo-agrialSAT-mobile {
  width: 2rem;
}
.logo-xarvio {
  width: 1.2rem;
}
.logo-farmstar {
  width: 1.4rem;
}
.margin-xarvio {
  margin-left: -70px;
}
.margin-xarvio-mobile {
  margin-left: -60px;
}
.card-oad {
  min-width: 290px;
}
</style>
